// src/pages/LoginPage.js
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import './LoginPage.css';

const API_URL = process.env.REACT_APP_API_URL;
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const LoginPage = ({ setIsAuthenticated }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  // 1) Create a ref to control the ReCAPTCHA component
  const recaptchaRef = useRef(null);

  // 2) Called by ReCAPTCHA when user successfully checks the box
  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  // Optionally, clear token if reCAPTCHA expires
  const handleCaptchaExpired = () => {
    setCaptchaToken('');
  };

  // Optionally, clear token if reCAPTCHA errors out
  const handleCaptchaErrored = () => {
    setCaptchaToken('');
  };

  // 3) Handle the login form submission
  const handleLogin = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      setErrorMessage("Please complete the reCAPTCHA.");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          email, 
          password, 
          recaptchaToken: captchaToken  // pass the token
        })
      });

      const data = await response.json();

      if (data.token) {
        // Successful login
        localStorage.setItem('token', data.token);
        setIsAuthenticated(true);
        navigate('/');
      } else {
        // If login fails or server responded with an error
        setErrorMessage(data.error || "Invalid credentials");

        // 4) Reset the reCAPTCHA on failure
        if (recaptchaRef.current) {
          recaptchaRef.current.reset(); // resets the widget in the UI
        }
        setCaptchaToken(''); // clear the token in state
      }
    } catch (err) {
      console.error(err);
      setErrorMessage("An error occurred. Please try again.");

      // Also reset the widget on any unexpected error
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
      setCaptchaToken('');
    }
  };

  return (
    <div className="login-page">
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label>Password:</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {/* 5) The reCAPTCHA widget */}
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={RECAPTCHA_SITE_KEY}
          onChange={handleCaptchaChange}
          onExpired={handleCaptchaExpired}
          onErrored={handleCaptchaErrored}
        />

        <button type="submit">Login</button>
      </form>

      {/* Conditionally render the error message */}
      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </div>
  );
};

export default LoginPage;
